module.exports = __webpack_public_path__ + "static/media/InviteCancel.5779151c.svg";